import script from "./view.vue?vue&type=script&setup=true&lang=js"
export * from "./view.vue?vue&type=script&setup=true&lang=js"

import "./view.vue?vue&type=style&index=0&id=b5df0f86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5df0f86"]])

export default __exports__